import React, { useContext, useEffect } from 'react';
import Alert from '@material-ui/lab/Alert';
import { useSpeechSynthesis } from 'react-speech-kit';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '../../helpers/colors';
import { useTranslation } from 'react-i18next';
import { audioDescription } from '../../helpers/audioDescription';
import { AppContext } from '../../AppContext';

const useStyles = makeStyles((theme) => ({
        alert: {
            color: colors.icon,
            backgroundColor: '#fff'
        },
        alertContainer: {
            position: 'absolute',
            zIndex: 100,
            top: 5,
            left: 5,
            [theme.breakpoints.up('sm')]: {
                left: 105,
            },
        }
    })
)


export const AlertDialog = React.memo(() => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const {t} = useTranslation();
    const { speak, cancel } = useSpeechSynthesis();

    const { alert, setAlert, isAudiodescription } = useContext(AppContext);

    useEffect(() => {
        if(!alert.state || alert.state === '') return;

        const timer = setTimeout(() => setAlert({state: '', text: ''}), alert.time ? alert.time : 3000);
    
        return () => clearTimeout(timer);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alert])

    if (!alert && alert.state && alert.text) return null

    return (
        <Collapse in={Boolean(alert.state)} className={classes.alertContainer}>
            <Alert
                className={classes.alert}
                severity={alert.state !== '' ? alert.state : 'info'}
                variant='outlined'
                action={<IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => setAlert({state: '', text: ''})}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>}
                onPointerEnter={() => audioDescription(cancel, speak, alert.text, t('lang'), isAudiodescription)}
            >
                {alert.text}
            </Alert>
        </Collapse>
    )
})